<template>
  <div>
    <!-- 飘窗效果 -->
    <div id="thediv"
         ref="thediv"
         style="position: fixed; z-index: 111; left: 0; top: 0"
         v-show="thedivShow"
         @mouseover="clearFdAd"
         @mouseout="starFdAd"
         @click.stop="openVideo">
      <div class="close"
           @click.stop="closeWindow">关闭</div>
      <div>
        <img src="https://shop.crcchc.com/index.png" />
      </div>
    </div>
    <!-- 视频播放 -->
    <div>
      <el-dialog title="铁建物产直营商城"
                 :visible.sync="dialogVisible"
                 width="70%"
                 center
                 @close="closeDialog"
                 destroy-on-close>
        <div style="width: 100%;display: flex;justify-content: center;">
          <video class="video"
                 controls
                 :src="videoUrl"
                 poster="https://shop.crcchc.com/index.png"
                 @playing="playVideo"
                 @pause="onPause"
                 @ended="onPause"></video>
        </div>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button type="primary"
                     @click="closeDialog">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
// var interval = null;
export default {
  props: {
    show: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      interval: null,
      xPos: 0,
      yPos: 0,
      xin: true,
      yin: true,
      step: 1,
      delay: 8,
      height: 0,
      Hoffset: 0,
      Woffset: 0,
      yon: 0,
      xon: 0,
      pause: true,
      thedivShow: true,

      dialogVisible: false,
      videoUrl: 'https://shop.crcchc.com/index.mp4',
    };
  },
  beforeCreate () {
    clearInterval(this.interval);
    this.interval = null
  },
  mounted () {
    if (this.show) {
      this.$nextTick(() => {
        if (this.thedivShow) {
          this.interval = setInterval(this.changePos, this.delay);
        }
      });
    }
  },
  methods: {
    changePos () {
      let width = document.documentElement.clientWidth;
      let height = document.documentElement.clientHeight;
      if (this.$refs.thediv) {
        this.Hoffset = !this.$refs.thediv.offsetHeight ? 0 : this.$refs.thediv.offsetHeight; //获取元素高度
        this.Woffset = !this.$refs.thediv.offsetWidth ? 0 : this.$refs.thediv.offsetWidth;

        // 滚动部分跟随屏幕滚动
        // this.$refs.thediv.style.left = (this.xPos + document.body.scrollLeft + document.documentElement.scrollLeft) + "px";
        // this.$refs.thediv.style.top = (this.yPos + document.body.scrollTop + document.documentElement.scrollTop) + "px";

        // 滚动部分不随屏幕滚动
        this.$refs.thediv.style.left = this.xPos + document.body.scrollLeft + "px";
        this.$refs.thediv.style.top = this.yPos + document.body.scrollTop + "px";

        if (this.yon) {
          this.yPos = this.yPos + this.step;
        } else {
          this.yPos = this.yPos - this.step;
        }
        if (this.yPos < 0) {
          this.yon = 1;
          this.yPos = 0;
        }
        if (this.yPos >= height - this.Hoffset) {
          this.yon = 0;
          this.yPos = height - this.Hoffset;
        }

        if (this.xon) {
          this.xPos = this.xPos + this.step;
        } else {
          this.xPos = this.xPos - this.step;
        }
        if (this.xPos < 0) {
          this.xon = 1;
          this.xPos = 0;
        }
        if (this.xPos >= width - this.Woffset) {
          this.xon = 0;
          this.xPos = width - this.Woffset;
        }
      }
    },
    clearFdAd () {
      clearInterval(this.interval);
    },
    starFdAd () {
      this.interval = setInterval(this.changePos, this.delay);
    },
    // 关闭飘窗
    closeWindow () {
      this.thedivShow = false
      this.$store.dispatch('saveFloatStatus', false)
    },
    // 打开视频
    openVideo () {
      this.dialogVisible = true
      this.thedivShow = false
      console.log(this.$refs.videoChild);
      clearInterval(this.interval);
    },
    closeDialog () {
      this.dialogVisible = false
      clearInterval(this.interval);
      this.$store.dispatch('saveFloatStatus', false)
    },
    // 视频播放
    playVideo () {
      console.log(111);

    },
    onPause () {

    },
  },
};
</script>

<style lang="scss" scoped>
#thediv {
  z-index: 100;
  position: fixed;
  top: 43px;
  left: 2px;
  height: 210px;
  width: 280px;
  overflow: hidden;
  .close {
    cursor: pointer;
    text-align: right;
    font-size: 14px;
    color: #999999;
    font-weight: bold;
    position: absolute;
    top: 5px;
    right: 10px;
  }
  img {
    width: 280px;
    height: 210px;
    box-shadow: 0px 2px 6px 2px rgba(0, 0, 0, 0.2);
  }
}
.video {
  width: 1200px;
  height: 600px;
}
::v-deep .el-dialog {
  margin-top: 50px !important;
}
</style>